import ga from './ga-init';
import sentry from './sentry-init';

const loadAnalytics = () => {
  ga.initGoogleAnalytics();
  sentry.initSentryAnalytics();
};

export default loadAnalytics;